var _mask, _mask2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSnapPeasImage = function SvgSnapPeasImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 144,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M147.784 73.57c0 38.881-31.535 70.401-70.434 70.401-38.9 0-92.477-8.146-54.084-63.487C46.535 33.341 13.833 3.17 77.35 3.17c38.899 0 70.434 31.52 70.434 70.4z",
    fill: props.accentFill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.091 102.079c5.586-3.724 72.922-48.68 104.729-70.4-5.237 7.563-47.904 50.424-68.656 70.4-8.145 1.164-24.902 3.491-26.764 3.491-2.327 0-16.29 1.164-9.309-3.491z",
    fill: "#fff0",
    stroke: props.fill,
    strokeWidth: 3
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "snap-peas-image_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 43,
    width: 40,
    height: 46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.02 43.897L64 83.461l16.292 5.237 23.273-25.019-14.546-19.782z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#snap-peas-image_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.019,
    cy: 73.57,
    r: 12.382,
    fill: props.accentFill,
    stroke: props.fill,
    strokeWidth: 2
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "snap-peas-image_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 70,
    width: 42,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.983 70.08l-31.419 31.999 16.873 7.564 24.437-25.018-9.891-14.546z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#snap-peas-image_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.237,
    cy: 94.516,
    r: 12.382,
    fill: props.accentFill,
    stroke: props.fill,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.129 20.624c-20.946 26.066-65.164 68.073-84.365 87.855-2.909 2.764-9.31 12.219-8.727 13.964.581 1.746 57.019-3.491 76.801-26.764 19.782-23.273 21.527-59.346 23.273-69.237 1.396-7.913-4.073-9.89-6.982-5.818z",
    fill: "#fff0",
    stroke: props.fill,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.911 2.005c-2.715-.388-9.542 2.328-15.127 16.291",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.055,
    cy: 111.97,
    r: 10.055,
    fill: "#fff0",
    stroke: props.fill,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M8.255 109.358l.381 1.442M11.993 114.388l.382 1.441M12.755 108.168l.381 1.441M62.305 93.626l.686 1.324M67.048 97.722l.686 1.324M66.438 91.486l.686 1.324M82.087 72.68l.686 1.324M86.83 76.777l.686 1.324M86.22 70.54l.686 1.324"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    d: "M85.421 65.932l2.661.319M66.884 87.679l2.661.318M79.593 70.715l1.832-1.956M60.487 92.422l1.831-1.956"
  }));
};
export default SvgSnapPeasImage;